/**
 * Guard reCAPTCHA v3 sur les boutons "Passer commande" (page /cart + cart drawer).
 * Objectif : bloquer les bots avant la redirection vers /checkout.
 *
 * Fonctionnement :
 *  1. reCAPTCHA v3 est chargé via snippet (script Google inclus avant nous).
 *  2. Sur clic d'un bouton [name="checkout"] :
 *     - Prevent default submit
 *     - Génère un token reCAPTCHA v3 (analyse comportement + fingerprint)
 *     - POST au Worker /verify-recaptcha qui appelle Google avec la secret key
 *     - Si {ok: true} → submit le formulaire cart normalement
 *     - Si {ok: false} → affiche un message d'erreur, ne submit pas
 *  3. Fail-open : si Worker/Google inaccessible, laisse passer (préserve les
 *     vrais clients au détriment de laisser passer quelques bots en cas de
 *     panne du service reCAPTCHA).
 */
(function () {
  var cfg = window.__recaptchaGuard || {};
  var SITE_KEY = cfg.siteKey;
  var VERIFY_URL = cfg.verifyUrl;
  if (!SITE_KEY || !VERIFY_URL) return;

  // Marqueur pour éviter la double-vérif : une fois qu'un form est validé côté
  // reCAPTCHA, on le submit ; le submit re-déclenche un click natif qu'on ignore
  // via ce flag pour ne pas boucler.
  var verifiedForm = null;

  function showBlockMessage(btn) {
    var msg = document.createElement('div');
    msg.setAttribute('role', 'alert');
    msg.style.cssText = 'margin-top:12px;padding:10px 14px;background:#fff3cd;border:1px solid #ffc107;border-radius:6px;color:#664d03;font-size:14px;';
    msg.textContent = "Nous n'avons pas pu vérifier votre requête. Si vous êtes bien un humain, rechargez la page et réessayez.";
    var host = btn.closest('.cart__ctas, .cart__footer, form') || btn.parentNode;
    host.querySelectorAll('[data-lep-recaptcha-msg]').forEach(function (n) { n.remove(); });
    msg.setAttribute('data-lep-recaptcha-msg', '1');
    host.appendChild(msg);
    setTimeout(function () { msg.remove(); }, 8000);
  }

  function submitForm(form) {
    verifiedForm = form;
    // Ré-injecte le champ 'checkout' pour que Shopify route bien vers /checkout
    var input = form.querySelector('input[name="checkout"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'checkout';
      input.value = '';
      form.appendChild(input);
    }
    form.submit();
  }

  function verifyAndSubmit(btn) {
    var form = btn.form || document.getElementById(btn.getAttribute('form'));
    if (!form) return;

    if (typeof grecaptcha === 'undefined' || !grecaptcha.ready) {
      // reCAPTCHA pas encore chargé → fail-open
      submitForm(form);
      return;
    }
    grecaptcha.ready(function () {
      grecaptcha.execute(SITE_KEY, { action: 'checkout' }).then(function (token) {
        var ctrl = new AbortController();
        var timer = setTimeout(function () { ctrl.abort(); }, 4000);
        fetch(VERIFY_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: token }),
          signal: ctrl.signal,
        }).then(function (r) { return r.json(); }).then(function (data) {
          clearTimeout(timer);
          if (data && data.ok) {
            submitForm(form);
          } else {
            btn.disabled = false;
            showBlockMessage(btn);
          }
        }).catch(function () {
          clearTimeout(timer);
          // Fail-open sur erreur réseau
          submitForm(form);
        });
      }).catch(function () {
        submitForm(form);
      });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="checkout"]');
    if (!btn) return;
    // Ignore les submits déclenchés par notre propre submitForm()
    var form = btn.form || document.getElementById(btn.getAttribute('form'));
    if (form && form === verifiedForm) return;

    e.preventDefault();
    e.stopPropagation();
    btn.disabled = true;
    verifyAndSubmit(btn);
  }, true);
})();
